import { API } from './Abstract';
export class SuggestAPI extends API {
    async getSuggest(queryParameters) {
        const headerParameters = {};
        const response = await this.request({
            path: '/api/suggest/query',
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, '/api/suggest/query' + JSON.stringify(queryParameters));
        return response;
    }
    async postSuggest(requestParameters) {
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: '/api/suggest/query',
            method: 'POST',
            headers: headerParameters,
            body: requestParameters,
        }, '/api/suggest/query' + JSON.stringify(requestParameters));
        return response;
    }
    async getTrending(queryParameters) {
        const headerParameters = {};
        const response = await this.request({
            path: '/api/suggest/trending',
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, '/api/suggest/trending' + JSON.stringify(queryParameters));
        return response;
    }
    async postTrending(requestParameters) {
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: '/api/suggest/trending',
            method: 'POST',
            headers: headerParameters,
            body: requestParameters,
        }, '/api/suggest/trending' + JSON.stringify(requestParameters));
        return response;
    }
}
